module.exports = __webpack_public_path__ + "img/phone_gray.6fa8974f.svg";